import React from 'react'
import { Link } from 'react-router-dom'


const BreadcrumbTwo = ({ title, breadcrumbTitle }) => {
    return (
        <div className="breadcrumb py-20 bg-main-one-50">
            <div className="container container-md">
                <div className="breadcrumb-wrapper flex-between flex-wrap gap-16">
                    <h6 className="text-xl text-main-one-600 mb-0">{title}</h6>
                    <ul className="flex-align gap-8 flex-wrap">
                        <li className="text-md">
                            <Link to="/" className="text-main-one-600 flex-align gap-8">
                                <i className="ph ph-house" />
                                Home
                            </Link>
                        </li>
                        <li className="flex-align text-gray-500">
                            <i className="ph ph-caret-right" />
                        </li>
                        <li className="text-md">
                            <Link to="/products" className="text-main-one-600 flex-align gap-8">
                                Products
                            </Link>
                        </li>
                        <li className="flex-align text-gray-500">
                            <i className="ph ph-caret-right" />
                        </li>
                        <li className="text-md text-neutral-600">{breadcrumbTitle ?? 'Product Name'}</li>
                    </ul>
                </div>
            </div>
        </div>

    )
}

export default BreadcrumbTwo